import { SET_BNPL_DESCRIPTION } from '../actionTypes/BNPLSectionActionTypes';

export default function BNPLSectionReducer(state = {}, action) {
    // NOSONAR
    switch (action.type) {
        case SET_BNPL_DESCRIPTION:
            return { ...state, data: action };
        default:
            return state;
    }
}

BNPLSectionReducer.reducerName = 'bnplSectionData';
